/* eslint-disable max-len */
import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { IonModal, ToastController } from '@ionic/angular';
import { firstValueFrom } from 'rxjs';
import { MHVoucher } from 'src/app/interfaces/api/voucher';
import { VoucherService } from 'src/app/services/voucher.service';

@Component({
  selector: 'app-voucher-list',
  templateUrl: './voucher-list.component.html',
  styleUrls: ['./voucher-list.component.scss'],
})
export class VoucherListComponent implements OnInit {
  @ViewChild(IonModal) modal: IonModal;
  @Input() transactionId: number;
  @Input() selectedVoucher: MHVoucher;
  @Output() takeVoucher = new EventEmitter();
  @Output() removeVoucher = new EventEmitter();
  isDesktopView: boolean;
  initialBreakpoint: number;
  breakpoints: number[] | undefined;

  isLoading: boolean;
  vouchers: MHVoucher[] = [];
  voucherDetail: MHVoucher;

  constructor(
    private voucherService: VoucherService,
    private sanitizer: DomSanitizer,
    private toastController: ToastController,
  ) {}

  ngOnInit() {
    this.isDesktopView = window.innerWidth > 576;

    if (this.isDesktopView) {
      this.initialBreakpoint = undefined;
      this.breakpoints = undefined;
    } else {
      this.initialBreakpoint = this.selectedVoucher ? 1 : 0.5;
      this.breakpoints = [0, 0.5, 0.75, 1];
    }

    this.getListVoucher();
  }

  onDidPresent(event) {
    if (!!this.selectedVoucher) {
      this.voucherDetail = this.selectedVoucher;
    }
  }

  getListVoucher() {
    this.voucherService.getVocuherList().subscribe({
      next: res => {
        this.vouchers = res.data;
        /* this.vouchers = Array.from({ length: 5 }, (_, i) => i + 1).map(i => ({
          created_at: null,
          current_stock: 10,
          description:
            'Lorem, ipsum dolor sit amet consectetur adipisicing elit. Assumenda nemo deserunt tempora reprehenderit fugiat repudiandae laborum consequuntur unde impedit sunt excepturi, asperiores neque aspernatur accusantium ratione omnis distinctio, alias exercitationem. Nostrum quibusdam facere eum distinctio mollitia sapiente, earum reprehenderit neque. Aliquid ex rem voluptatibus. Excepturi aut qui ea officia facilis?',
          discount_amount: 10000,
          discount_in_percent: `${10 * i}`,
          id: i,
          id_mh_voucher_category: 1,
          image: null,
          image_thumb: null,
          image_url: '',
          maximum_take: 1,
          minimum_transaction: 200000,
          name: `Diskon ongkir ${10 * i}%`,
          point: 1500,
          redeem_duration: 200,
          redeem_end_at: '2024-11-30T17:00:00.000000Z',
          redeem_start_at: '2024-02-29T17:00:00.000000Z',
          take_end_at: '2024-11-30T17:00:00.000000Z',
          take_start_at: '2024-02-29T17:00:00.000000Z',
          tnc: 'Lorem, ipsum dolor sit amet consectetur adipisicing elit. Assumenda nemo deserunt tempora reprehenderit fugiat repudiandae laborum consequuntur unde impedit sunt excepturi, asperiores neque aspernatur accusantium ratione omnis distinctio, alias exercitationem. Nostrum quibusdam facere eum distinctio mollitia sapiente, earum reprehenderit neque. Aliquid ex rem voluptatibus. Excepturi aut qui ea officia facilis?',
          type: 1,
          type_text: 'Voucher Ongkir',
        })); */
        console.log(this.vouchers);
      },
      complete: () => {
        this.isLoading = false;
      },
    });
  }

  viewVoucherDetail(voucher: MHVoucher) {
    this.voucherDetail = voucher;
    this.modal.setCurrentBreakpoint(1);
  }

  async takeVoucherHandler() {
    if (!this.voucherDetail) {
      return;
    }

    const checkResponse = await this.checkVoucher(this.voucherDetail);

    if (!checkResponse?.grand_total_after_voucher || !checkResponse?.grand_total_before_voucher) {
      this.presentToast('transaksi tidak memenuhi syarat untuk menggunakan voucher ini', 2500, 'danger');
      this.selectedVoucher = null;
      this.voucherDetail = null;
      this.modal.setCurrentBreakpoint(0);
      this.modal.dismiss(null, 'cancel');
      return;
    }

    const data = {
      selectedVoucher: this.voucherDetail,
      grand_total_after_voucher: checkResponse.grand_total_after_voucher,
      grand_total_before_voucher: checkResponse.grand_total_before_voucher,
    };

    this.selectedVoucher = this.voucherDetail;
    this.modal.dismiss(data, 'confirm');
    this.takeVoucher.emit(data);
  }

  removeVoucherHandler() {
    this.selectedVoucher = null;
    this.voucherDetail = null;
    this.modal.setCurrentBreakpoint(0);
    this.modal.dismiss(null, 'cancel');
    this.removeVoucher.emit();
  }

  backToList() {
    this.voucherDetail = null;
    // this.modal.setCurrentBreakpoint(0.5);
  }

  closeModal() {
    this.voucherDetail = this.selectedVoucher;
    this.modal.setCurrentBreakpoint(0);
    this.modal.dismiss(null, 'cancel');
  }

  async checkVoucher(data: MHVoucher) {
    try {
      const res = await firstValueFrom(
        this.voucherService.checkVoucher({ transactionId: this.transactionId, voucherId: data.id }),
      );

      if (!res.grand_total_after_voucher && !res.grand_total_before_voucher) {
        return null;
      }

      return {
        grand_total_after_voucher: res.grand_total_after_voucher,
        grand_total_before_voucher: res.grand_total_before_voucher,
      };
    } catch (error) {
      console.error(error);
      return null;
    }
  }

  toNumber(str: string) {
    if (!str) {
      return 0;
    }

    return parseFloat(str);
  }

  sanitizeHTML(str: string) {
    return this.sanitizer.bypassSecurityTrustHtml(str);
  }

  protected async presentToast(message: string, duration: number = 1000, color: string): Promise<void> {
    const toast = await this.toastController.create({
      message,
      duration,
      mode: 'ios',
      color: color ?? null,
    });
    return await toast.present();
  }

  /* onWillDismiss(event: Event) {
    const ev = event as CustomEvent<OverlayEventDetail<string>>;

    const role = ev.detail.role;
    const data = ev.detail.data;

    console.log(role);

    if (!role || role !== 'confirm') {
      return;
    }

    console.log('closing...');
    this.modal.setCurrentBreakpoint(0);
  } */
}
